import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { http, HttpResponse } from "msw";
import i18next from "i18next";
import GetCapabilitiesMixin from "../../../../lib/ModelMixins/GetCapabilitiesMixin";
import WebFeatureServiceCatalogItem from "../../../../lib/Models/Catalog/Ows/WebFeatureServiceCatalogItem";
import Terria from "../../../../lib/Models/Terria";
import { worker } from "../../../mocks/browser";
import getCapabilities from "../../../../wwwroot/test/WFS/getCapabilities.xml";
describe("WebFeatureServiceCatalogItem", function () {
  let terria;
  let wfs;
  beforeEach(() => {
    terria = new Terria();
    wfs = new WebFeatureServiceCatalogItem("test", terria);
  });
  it("derives getCapabilitiesUrl from url if getCapabilitiesUrl is not specified", function () {
    wfs.setTrait("definition", "url", "foo.bar.baz");
    expect(wfs.getCapabilitiesUrl).toBeDefined();
    expect(wfs.url).toBeDefined();
    expect(wfs.getCapabilitiesUrl && wfs.getCapabilitiesUrl.indexOf(wfs.url || "undefined") === 0).toBe(true);
  });
  describe("GetCapabilities", function () {
    beforeEach(() => {
      wfs.setTrait("definition", "url", "test/WFS/getCapabilities.xml");
      wfs.setTrait("definition", "typeNames", "name_of_feature_type");
    });
    it("loads get capabilities", async () => {
      expect((await wfs.loadMetadata()).error).toBeUndefined();
    });
    it("updates description from a GetCapabilities", async function () {
      var _wfs$info$find;
      (await wfs.loadMetadata()).throwIfError();
      expect((_wfs$info$find = wfs.info.find(section => section.name === i18next.t("models.webFeatureServiceCatalogItem.abstract"))) === null || _wfs$info$find === void 0 ? void 0 : _wfs$info$find.content).toBe("Abstract of feature type");
    });
    it("updates rectangle from a GetCapabilities", async function () {
      (await wfs.loadMetadata()).throwIfError();
      expect(wfs.rectangle.west).toBeCloseTo(142.163757324219, 5);
      expect(wfs.rectangle.east).toBeCloseTo(153.598999023438, 5);
      expect(wfs.rectangle.south).toBeCloseTo(-28.2700939178467, 5);
      expect(wfs.rectangle.north).toBeCloseTo(-10.4980516433716, 5);
    });
    it("pulls correct SRS from GetCapabilities", async function () {
      var _strata$capabilities$;
      (await wfs.loadMetadata()).throwIfError();
      const strata = wfs.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
      const layerSrsArray = (_strata$capabilities$ = strata.capabilities.srsNames) === null || _strata$capabilities$ === void 0 ? void 0 : _strata$capabilities$.find(layer => layer.layerName === "name_of_feature_type");
      expect(layerSrsArray === null || layerSrsArray === void 0 ? void 0 : layerSrsArray.srsArray).toEqual(["urn:x-ogc:def:crs:EPSG:4283",
      // From DefaultCRS
      "urn:x-ogc:def:crs:EPSG:4326",
      // From OtherCRS
      "urn:x-ogc:def:crs:EPSG:900913" // From OtherCRS
      ]);
      expect(wfs.srsName).toBe("urn:x-ogc:def:crs:EPSG:4326");
    });
    it("pulls correct output formats from GetCapabilities", async function () {
      (await wfs.loadMetadata()).throwIfError();
      const strata = wfs.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
      expect(strata.capabilities.outputTypes).toEqual(["text/xml; subtype=gml/3.1.1", "GML2", "KML", "SHAPE-ZIP", "application/gml+xml; version=3.2", "application/json", "application/vnd.google-earth.kml xml", "application/vnd.google-earth.kml+xml", "csv", "gml3", "gml32", "json", "text/csv", "text/xml; subtype=gml/2.1.2", "text/xml; subtype=gml/3.2"]);
      expect(wfs.outputFormat).toBe("JSON");
    });
  });
  describe("GetFeature", function () {
    beforeEach(() => {
      wfs.setTrait("definition", "url", "test/WFS/getCapabilities.xml");
      wfs.setTrait("definition", "typeNames", "name_of_feature_type");
      worker.use(http.get("*/test/WFS/getCapabilities.xml", _ref => {
        let {
          request
        } = _ref;
        const url = new URL(request.url);
        if (url.searchParams.get("request") === "GetFeature") {
          return HttpResponse.json({
            type: "FeatureCollection",
            name: "Test data",
            features: [{
              type: "Feature",
              properties: {
                someProp: "someValue"
              },
              geometry: {
                type: "LineString",
                coordinates: [[143.876421625763385, -37.565365204704129, 0.0], [143.878406116725529, -37.565587782094575, 0.0], [143.878637784265578, -37.565655550547291, 0.0]]
              }
            }]
          });
        }
        if (url.searchParams.get("request") === "GetCapabilities") {
          return HttpResponse.xml(getCapabilities);
        }
        throw new Error("Unexpected query params: ".concat(url.search));
      }));
    });
    it("fetches GeoJSON", async () => {
      var _wfs$readyData, _wfs$readyData2, _feature$properties;
      (await wfs.loadMapItems()).throwIfError();
      expect((_wfs$readyData = wfs.readyData) === null || _wfs$readyData === void 0 || (_wfs$readyData = _wfs$readyData.features) === null || _wfs$readyData === void 0 ? void 0 : _wfs$readyData.length).toBe(1);
      const feature = (_wfs$readyData2 = wfs.readyData) === null || _wfs$readyData2 === void 0 ? void 0 : _wfs$readyData2.features[0];
      expect(feature === null || feature === void 0 ? void 0 : feature.type).toBe("Feature");
      expect(feature === null || feature === void 0 || (_feature$properties = feature.properties) === null || _feature$properties === void 0 ? void 0 : _feature$properties.someProp).toBe("someValue");
    });
  });
});